import { Box } from "@chakra-ui/react";

type ZorbieProps = {
  color: string;
  type: "up" | "down" | "left" | "right" | "happy";
};

export const Zorbie = ({ color, type }: ZorbieProps) => (
  <Box w="100%" h="100%" position="absolute" zIndex="2">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Ellipse"
          fill={color}
          fill-rule="evenodd"
          stroke="none"
          d="M 498.3125 958 C 347.1185 958 251.221954 902.197205 225.615234 775.710938 C 211.984573 708.381226 296.007538 639.586975 302.121094 552.84375 C 306.419647 491.853241 241.083237 386.168945 273.457031 312.134766 C 310.562012 227.281006 372.366425 148.941406 498.3125 148.941406 C 499.680817 148.941406 501.039856 148.954651 502.394531 148.972656 C 491.806946 137.844604 481.668518 125.711792 476.408203 115.4375 C 467.821014 98.665405 452.894653 78.490906 465.048828 60.0625 C 477.203033 41.634094 501.99353 36.546997 520.421875 48.701172 C 538.850281 60.855408 524.577454 72.895935 509.417969 88.943359 C 501.55188 97.270142 511.932434 126.293579 522.425781 149.919922 C 633.077332 159.057556 694.755615 231.159363 729.548828 312.134766 C 761.558044 386.630981 690.989075 491.434265 694.503906 552.84375 C 699.484985 639.870239 786.767395 708.381226 773.136719 775.710938 C 747.529968 902.197205 649.506409 958 498.3125 958 Z"
        />
        <mask
          id="zorbiemask2"
          maskUnits="userSpaceOnUse"
          maskContentUnits="userSpaceOnUse"
          mask-type="alpha"
        >
          <path
            id="path1"
            fill={color}
            fill-rule="evenodd"
            stroke="none"
            d="M 498.3125 958 C 347.1185 958 251.221954 902.197205 225.615234 775.710938 C 211.984573 708.381226 296.007538 639.586975 302.121094 552.84375 C 306.419647 491.853241 241.083237 386.168945 273.457031 312.134766 C 310.562012 227.281006 372.366425 148.941406 498.3125 148.941406 C 499.680817 148.941406 501.039856 148.954651 502.394531 148.972656 C 491.806946 137.844604 481.668518 125.711792 476.408203 115.4375 C 467.821014 98.665405 452.894653 78.490906 465.048828 60.0625 C 477.203033 41.634094 501.99353 36.546997 520.421875 48.701172 C 538.850281 60.855408 524.577454 72.895935 509.417969 88.943359 C 501.55188 97.270142 511.932434 126.293579 522.425781 149.919922 C 633.077332 159.057556 694.755615 231.159363 729.548828 312.134766 C 761.558044 386.630981 690.989075 491.434265 694.503906 552.84375 C 699.484985 639.870239 786.767395 708.381226 773.136719 775.710938 C 747.529968 902.197205 649.506409 958 498.3125 958 Z"
          />
        </mask>
        <g id="g1" mask="url(#zorbiemask2)">
          {type === "down" && (
            <g id="Face-Forward">
              <g id="eyes" className="blink">
                <g id="Group-copy">
                  <path
                    id="path2"
                    fill="#ffffff"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 660.585938 291.967468 C 660.585938 259.519043 634.281311 233.214417 601.832886 233.214417 C 569.38446 233.214417 543.079834 259.519043 543.079834 291.967468 C 543.079834 324.415894 569.38446 350.72052 601.832886 350.72052 C 634.281311 350.72052 660.585938 324.415894 660.585938 291.967468 Z"
                  />
                  <path
                    id="Ellipse-copy"
                    fill="#000000"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 624.069214 322.232544 C 624.069214 310.357361 610.585938 300.730591 593.953369 300.730591 C 577.320862 300.730591 563.837524 310.357361 563.837524 322.232544 C 563.837524 334.107788 577.320862 343.734558 593.953369 343.734558 C 610.585938 343.734558 624.069214 334.107788 624.069214 322.232544 Z"
                  />
                </g>
                <g id="Group-copy-2">
                  <path
                    id="path3"
                    fill="#ffffff"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 339.639313 291.967468 C 339.639313 259.519043 365.943939 233.214417 398.392365 233.214417 C 430.840759 233.214417 457.145386 259.519043 457.145386 291.967468 C 457.145386 324.415894 430.840759 350.72052 398.392365 350.72052 C 365.943939 350.72052 339.639313 324.415894 339.639313 291.967468 Z"
                  />
                  <path
                    id="path4"
                    fill="#000000"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 376.156006 322.232544 C 376.156006 310.357361 389.639343 300.730591 406.271851 300.730591 C 422.904388 300.730591 436.387695 310.357361 436.387695 322.232544 C 436.387695 334.107788 422.904388 343.734558 406.271851 343.734558 C 389.639343 343.734558 376.156006 334.107788 376.156006 322.232544 Z"
                  />
                </g>
              </g>
              <path
                id="path5"
                fill="#000000"
                fill-rule="evenodd"
                stroke="none"
                d="M 562.581787 407.069946 C 562.581787 388.983948 534.552246 374.322327 499.976105 374.322327 C 465.399933 374.322327 437.370422 388.983948 437.370422 407.069946 C 437.370422 425.155945 465.399933 439.817505 499.976105 439.817505 C 534.552246 439.817505 562.581787 425.155945 562.581787 407.069946 Z"
              />
            </g>
          )}
          {type === "happy" && (
            <g id="Face-Happy">
              <g id="eyes" className="blink">
                <g id="g4">
                  <path
                    id="path11"
                    fill="#ffffff"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 339.639313 291.967468 C 339.639313 259.519043 365.943939 233.214417 398.392365 233.214417 C 430.840759 233.214417 457.145386 259.519043 457.145386 291.967468 C 457.145386 324.415894 430.840759 350.72052 398.392365 350.72052 C 365.943939 350.72052 339.639313 324.415894 339.639313 291.967468 Z"
                  />
                  <path
                    id="path12"
                    fill="#000000"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 382.41571 283.977295 C 382.41571 272.102112 395.899048 262.475342 412.531586 262.475342 C 429.164093 262.475342 442.64743 272.102112 442.64743 283.977295 C 442.64743 295.852539 429.164093 305.479309 412.531586 305.479309 C 395.899048 305.479309 382.41571 295.852539 382.41571 283.977295 Z"
                  />
                </g>
                <g id="Group-copy-4">
                  <path
                    id="path13"
                    fill="#ffffff"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 660.145386 291.967468 C 660.145386 259.519043 633.840759 233.214417 601.392334 233.214417 C 568.94397 233.214417 542.639343 259.519043 542.639343 291.967468 C 542.639343 324.415894 568.94397 350.72052 601.392334 350.72052 C 633.840759 350.72052 660.145386 324.415894 660.145386 291.967468 Z"
                  />
                  <path
                    id="path14"
                    fill="#000000"
                    fill-rule="evenodd"
                    stroke="none"
                    d="M 617.369019 283.977295 C 617.369019 272.102112 603.885681 262.475342 587.253113 262.475342 C 570.620605 262.475342 557.137268 272.102112 557.137268 283.977295 C 557.137268 295.852539 570.620605 305.479309 587.253113 305.479309 C 603.885681 305.479309 617.369019 295.852539 617.369019 283.977295 Z"
                  />
                </g>
              </g>
              <path
                id="path15"
                fill="#000000"
                fill-rule="evenodd"
                stroke="none"
                d="M 602.27002 407.069885 C 602.27002 388.983887 534.097412 389.005493 500 389 C 466.250214 388.994568 398.829468 388.983887 398.829468 407.069885 C 398.829468 425.155884 443.821442 484 500 484 C 556.178589 484 602.27002 425.155884 602.27002 407.069885 Z"
              />
            </g>
          )}
          {type === "left" && (
            <g id="Face-Left">
              <g id="g5" className="blink">
                <path
                  id="path16"
                  fill="#ffffff"
                  fill-rule="evenodd"
                  stroke="none"
                  d="M 447.755829 291.967468 C 447.755829 259.519043 421.451202 233.214417 389.002808 233.214417 C 356.554382 233.214417 330.249756 259.519043 330.249756 291.967468 C 330.249756 324.415894 356.554382 350.72052 389.002808 350.72052 C 421.451202 350.72052 447.755829 324.415894 447.755829 291.967468 Z"
                />
                <path
                  id="path17"
                  fill="#000000"
                  fill-rule="evenodd"
                  stroke="none"
                  d="M 402.892853 312.843018 C 402.892853 300.967773 389.409546 291.341003 372.777008 291.341003 C 356.14447 291.341003 342.661163 300.967773 342.661163 312.843018 C 342.661163 324.718201 356.14447 334.344971 372.777008 334.344971 C 389.409546 334.344971 402.892853 324.718201 402.892853 312.843018 Z"
                />
              </g>
              <path
                id="path18"
                fill="#000000"
                fill-rule="evenodd"
                stroke="none"
                d="M 349.751678 407.069946 C 349.751678 388.983948 321.722168 374.322327 287.145996 374.322327 C 252.569839 374.322327 224.540314 388.983948 224.540314 407.069946 C 224.540314 425.155945 252.569839 439.817505 287.145996 439.817505 C 321.722168 439.817505 349.751678 425.155945 349.751678 407.069946 Z"
              />
            </g>
          )}
          {type === "right" && (
            <g id="Face-Right">
              <g id="g6" className="blink">
                <path
                  id="path19"
                  fill="#ffffff"
                  fill-rule="evenodd"
                  stroke="none"
                  d="M 551.08844 291.967468 C 551.08844 259.519043 577.393066 233.214417 609.841492 233.214417 C 642.289917 233.214417 668.594543 259.519043 668.594543 291.967468 C 668.594543 324.415894 642.289917 350.72052 609.841492 350.72052 C 577.393066 350.72052 551.08844 324.415894 551.08844 291.967468 Z"
                />
                <path
                  id="path20"
                  fill="#000000"
                  fill-rule="evenodd"
                  stroke="none"
                  d="M 595.951416 312.843018 C 595.951416 300.967773 609.434753 291.341003 626.067261 291.341003 C 642.699768 291.341003 656.183105 300.967773 656.183105 312.843018 C 656.183105 324.718201 642.699768 334.344971 626.067261 334.344971 C 609.434753 334.344971 595.951416 324.718201 595.951416 312.843018 Z"
                />
              </g>
              <path
                id="path21"
                fill="#000000"
                fill-rule="evenodd"
                stroke="none"
                d="M 649.09259 407.069946 C 649.09259 388.983948 677.122131 374.322327 711.698303 374.322327 C 746.274475 374.322327 774.303955 388.983948 774.303955 407.069946 C 774.303955 425.155945 746.274475 439.817505 711.698303 439.817505 C 677.122131 439.817505 649.09259 425.155945 649.09259 407.069946 Z"
              />
            </g>
          )}
        </g>
      </g>
    </svg>
  </Box>
);
